import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll position to the top on route change. Skips when the URL carries
 * a hash anchor (e.g. /destinations#europe) so deep links keep working. Mounted
 * once inside PublicLayout — fixes the mobile-Safari issue where in-page scroll
 * would persist between routes.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Use `auto` — instant jump feels right between page transitions; smooth
    // scrolling here can race with route-mount animations.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
